var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-overlay',{attrs:{"value":_vm.openDialog,"color":"white"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"65","color":"primary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }